import { createFileRoute } from "@tanstack/react-router";
import { TipsPage } from "./tips";

export const Route = createFileRoute("/en/tips")({
  head: () => ({
    meta: [
      { title: "Tips for selling your things faster | Sellavo" },
      { name: "description", content: "Practical tips that make your listing sell faster: photos, price, text and timing." },
      { property: "og:title", content: "Tips for selling your things faster | Sellavo" },
      { property: "og:description", content: "Practical tips that make your listing sell faster: photos, price, text and timing." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/tips" }],
  }),
  component: TipsPage,
});
